import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { instance } from '../../../../api/instance';
import { IOrder } from '../../../../types';
import {
  CheckoutDetailsView,
  CheckoutError,
} from '../../../components/orders/checkout-details-view';

export default function CheckoutDetail() {
  const { slug } = useParams();
  const [result, setResult] = useState<{
    slug?: string;
    order?: IOrder;
    error?: CheckoutError;
  }>({});
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setResult({ slug });
    instance
      .get(`/admin/order/checkouts/${encodeURIComponent(slug ?? '')}`)
      .then(({ data }) => {
        if (active) setResult({ slug, order: data.data ?? data });
      })
      .catch((error) => {
        if (active)
          setResult({
            slug,
            error:
              error.response?.status === 403
                ? 'forbidden'
                : error.response?.status === 404
                ? 'missing'
                : 'failed',
          });
      });
    return () => {
      active = false;
    };
  }, [slug, attempt]);
  const current = result.slug === slug ? result : {};
  return (
    <CheckoutDetailsView
      slug={slug}
      order={current.order}
      error={current.error}
      onRetry={() => {
        setResult({ slug });
        setAttempt((n) => n + 1);
      }}
    />
  );
}
